import type { HasUncontactedBestApplyResponseData } from '@app/api/v1/patients/applies/has-uncontacted-best-apply/types'
import { RequestMethod } from '@lib/api/consts'
import internalJsonFetch from '@lib/api/internalJsonFetch'
import ApiRoutes from '@lib/routes/ApiRoutes'
export default async function getHasUncontactedBestApply() {
  return internalJsonFetch<HasUncontactedBestApplyResponseData>({
    authenticated: true,
    requestMethod: RequestMethod.POST,
    url: ApiRoutes.v1.patients.applies.hasUncontactedBestApply,
  })
}
